import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import routes from 'app/routes';

export default function useEnterpriseBriefs({ enterpriseId }) {
  const [enterpriseBriefs, setEnterpriseBriefs] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    const params = {};
    if (enterpriseId !== null) {
      params.enterprise_id = enterpriseId;
    }

    axios
      .get(routes.api.enterprise_briefs.index, { params })
      .then((response) => {
        setEnterpriseBriefs(response.data.data);
      });
  }, [enterpriseId, shouldRefetch]);

  return [enterpriseBriefs, refresh];
}

useEnterpriseBriefs.propTypes = {
  enterpriseId: PropTypes.number,
};

useEnterpriseBriefs.defaultProps = {
  enterpriseId: null,
};
